module.exports = __webpack_public_path__ + "img/courseTitle.31707eac.png";